const currencyFormatter = (value) => {
  if (value) {
    const int = parseInt(value, 10)
    return `Rp. ${Number(int).toLocaleString().replace(/,/g, '.')}`
  }
  return '-'
}
export default currencyFormatter
